import { render, staticRenderFns } from "./Recover.vue?vue&type=template&id=39ff583b"
import script from "./Recover.vue?vue&type=script&lang=ts"
export * from "./Recover.vue?vue&type=script&lang=ts"
import style0 from "./Recover.vue?vue&type=style&index=0&id=39ff583b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports